export default {
  needingPoint: 'Points need to be filled up on the Wannasport user!'
}